import { BoletoTransaction, Parcelas } from "@/lib/api";

/**
 * Converte uma `BoletoTransaction` no objeto `Parcelas` necessário
 * para abrir o componente de geração de boleto.
 *
 * Centraliza a lógica que era duplicada em Financial.tsx e ClientDetails.tsx.
 */
export function buildBoletoParcelasFromTransaction(transaction: BoletoTransaction): Parcelas {
    return {
        parmJournalTransRecId: transaction.parmJournalTransRecId,
        recIdBoleto: transaction.recIdBoleto ?? null,
        monthYear: `Boleto Mensal - ${transaction.monthYear}`,
        dueDate: transaction.dueDate,
        oldAmount: transaction.oldAmount,
        newAmount: transaction.newAmount > 0 ? transaction.newAmount : transaction.oldAmount,
        statusLabel: transaction.statusLabel,
        hasBoleto: true,
        cnpjCpf: transaction.cnpjCpf,
        paymentStatus: transaction.paymentStatus,
        hasCorrection: transaction.hasCorrection,
        parmBltAceite: transaction.parmBltAceite || "",
        parmBltAlunoNome: transaction.parmBltAlunoNome || "",
        parmBltAtualizouHtml: transaction.parmBltAtualizouHtml || 0,
        parmBltBankCode: transaction.parmBltBankCode || "",
        parmBltCedenteCnpjCpf: transaction.parmBltCedenteCnpjCpf || "",
        parmBltCedenteCodigo: transaction.parmBltCedenteCodigo || "",
        parmBltCedenteNome: transaction.parmBltCedenteNome || "",
        parmBltCodBarras: transaction.parmBltCodBarras || "",
        parmBltCodigoDv: transaction.parmBltCodigoDv || "",
        parmBltCodigoOcorrencia: transaction.parmBltCodigoOcorrencia || "",
        parmBltCodigoTransmissao: transaction.parmBltCodigoTransmissao || "",
        parmBltContaBancariaAgencia: transaction.parmBltContaBancariaAgencia || "",
        parmBltContaBancariaCarteiraPadrao: transaction.parmBltContaBancariaCarteiraPadrao || "",
        parmBltContaBancariaConta: transaction.parmBltContaBancariaConta || "",
        parmBltContaBancariaDigitoAgencia: transaction.parmBltContaBancariaDigitoAgencia || "",
        parmBltContaBancariaDigitoConta: transaction.parmBltContaBancariaDigitoConta || "",
        parmBltContaBancariaMensagemFixaTopoBoleto: transaction.parmBltContaBancariaMensagemFixaTopoBoleto || "",
        parmBltContaBancariaOperacaoConta: transaction.parmBltContaBancariaOperacaoConta || "",
        parmBltContaBancariaTipoCarteiraPadrao: transaction.parmBltContaBancariaTipoCarteiraPadrao || 0,
        parmBltContaBancariaTipoDocumento: transaction.parmBltContaBancariaTipoDocumento || 0,
        parmBltContaBancariaTipoFormaCadastramento: transaction.parmBltContaBancariaTipoFormaCadastramento || 0,
        parmBltContaBancariaTipoImpressaoBoleto: transaction.parmBltContaBancariaTipoImpressaoBoleto || 0,
        parmBltContaBancariaVariacaoCarteiraPadrao: transaction.parmBltContaBancariaVariacaoCarteiraPadrao || "",
        parmBltDataEmissao: transaction.parmBltDataEmissao || "",
        parmBltDataVencimento: transaction.parmBltDataVencimento || "",
        parmBltDescricaoOcorrencia: transaction.parmBltDescricaoOcorrencia || "",
        parmBltDetalheDaFatura: transaction.parmBltDetalheDaFatura || "",
        parmBltEnderecoLogradouroBairro: transaction.parmBltEnderecoLogradouroBairro || "",
        parmBltEnderecoLogradouroCep: transaction.parmBltEnderecoLogradouroCep || "",
        parmBltEnderecoLogradouroCidade: transaction.parmBltEnderecoLogradouroCidade || "",
        parmBltEnderecoLogradouroComplemento: transaction.parmBltEnderecoLogradouroComplemento || "",
        parmBltEnderecoLogradouroEndereco: transaction.parmBltEnderecoLogradouroEndereco || "",
        parmBltEnderecoLogradouroNumero: transaction.parmBltEnderecoLogradouroNumero || "",
        parmBltEnderecoLogradouroUf: transaction.parmBltEnderecoLogradouroUf || "",
        parmBltEnderecoSacadoBairro: transaction.parmBltEnderecoSacadoBairro || "",
        parmBltEnderecoSacadoCep: transaction.parmBltEnderecoSacadoCep || "",
        parmBltEnderecoSacadoCidade: transaction.parmBltEnderecoSacadoCidade || "",
        parmBltEnderecoSacadoComplemento: transaction.parmBltEnderecoSacadoComplemento || "",
        parmBltEnderecoSacadoEndereco: transaction.parmBltEnderecoSacadoEndereco || "",
        parmBltEnderecoSacadoNumero: transaction.parmBltEnderecoSacadoNumero || "",
        parmBltEnderecoSacadoUf: transaction.parmBltEnderecoSacadoUf || "",
        parmBltEspecieDocumento: transaction.parmBltEspecieDocumento || 0,
        parmBltGmPacoteDeCursoDescricao: transaction.parmBltGmPacoteDeCursoDescricao || "",
        parmBltGmTurnoNome: transaction.parmBltGmTurnoNome || "",
        parmBltGrupoDemonstrativo: transaction.parmBltGrupoDemonstrativo || "",
        parmBltMensagemInformacaoAdicional: transaction.parmBltMensagemInformacaoAdicional || "",
        parmBltMensagemInstrucoesCaixa: transaction.parmBltMensagemInstrucoesCaixa || "",
        parmBltMsgReferenciaPedido: transaction.parmBltMsgReferenciaPedido || "",
        parmBltNumeroControleParticipante: transaction.parmBltNumeroControleParticipante || "",
        parmBltNumeroDocumento: transaction.parmBltNumeroDocumento || "",
        parmBltSacadoCnpjCpf: transaction.parmBltSacadoCnpjCpf || "",
        parmBltSacadoNome: transaction.parmBltSacadoNome || "",
        parmBltValorTitulo: transaction.parmBltValorTitulo || 0,
        parmBase64PdfBoleto: transaction.parmBase64PdfBoleto || "",
        linhaDigitavel: transaction.linhaDigitavel || "",
        lines: transaction.lines || [],
    };
}
